import React from 'react';
import { ArrowPathIcon, XMarkIcon } from '@heroicons/react/24/outline';

export default function UpdateBanner({ onUpdate, onDismiss }) {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-primary text-white px-4 py-3 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <ArrowPathIcon className="h-5 w-5" />
          <span className="text-sm font-medium">
            A new version is available
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onUpdate}
            className="bg-white text-primary px-3 py-1.5 rounded text-sm font-medium hover:bg-gray-100 transition-colors"
          >
            Update Now
          </button>
          <button
            onClick={onDismiss}
            className="p-1.5 hover:bg-white/20 rounded transition-colors"
            aria-label="Dismiss"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
